export { default as AgentRating } from './agent-rating';
export type { AgentRatingProps } from './types';
